/**
 * Approved-domain entries for the visitor-tracking origin allowlist (ORB-458).
 *
 * The host rules themselves are generic and are now shared with the ORB-619 non-prospect domain
 * lists, so they live in `domainHost.ts`. This module keeps the approval-specific cap and re-exports
 * the shared helpers under the names its existing callers already use.
 */
import { findCoveringHost, isHostCoveredBy, normalizeHost } from './domainHost'

/** Server-side cap on the custom allowlist (mirrors TrackingValidationConstants.ApprovedDomainsMaxCount). */
export const APPROVED_DOMAINS_MAX_COUNT = 50

/**
 * Reduces a user-supplied entry to a bare, comparable host — see `normalizeHost`. Mirrors the API's
 * `ApprovedDomainNormalizer` so dashboard-side validation and the server's save path never disagree.
 */
export const normalizeApprovedDomain = normalizeHost

/**
 * Returns the approved entry that authorizes `host`, or null when none does — see `findCoveringHost`.
 * Pass both the custom allowlist and the derived hosts, since ingestion accepts an origin matched by
 * either.
 *
 * Public suffixes are deliberately not special-cased: approving `github.io` covers every
 * `*.github.io` here exactly as it does at the API today. Guarding that is ORB-495, with the CNAME
 * work — until then the dashboard must not claim a page is rejected when the API would accept it.
 */
export const findCoveringDomain = findCoveringHost

/** True when any entry authorizes `host` under the API's origin rule. See `findCoveringDomain`. */
export const isHostCovered = isHostCoveredBy
